import type { PortalCartDto } from '@supply-mover-2-0/shared';
import { create } from 'zustand';

interface CartState {
	/** The full cart DTO from the API, or null if no cart exists */
	cart: PortalCartDto | null;
	isLoading: boolean;
	/** Total number of line items in the cart */
	totalQuantity: number;

	setCart: (cart: PortalCartDto | null) => void;
	setLoading: (value: boolean) => void;
	clear: () => void;
}

export const useCartStore = create<CartState>((set) => ({
	cart: null,
	isLoading: false,
	totalQuantity: 0,

	setCart: (cart) =>
		set({
			cart,
			totalQuantity: cart?.lineItems.length ?? 0,
		}),

	setLoading: (value) => set({ isLoading: value }),

	clear: () => set({ cart: null, totalQuantity: 0 }),
}));
